import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { TOLL_EXTRAORDINARY_ASSIGNMENT_PATH } from '../../../../config/paths';
import DeleteTollExtraordinaryAssignmentButton from './DeleteTollExtraordinaryAssignmentButton';

const TollExtraordinaryAssignmentToolBar = ({
  tollExtraordinaryAssignmentId,
}) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${TOLL_EXTRAORDINARY_ASSIGNMENT_PATH}/${tollExtraordinaryAssignmentId}/edit`}
      />{' '}
      <DeleteTollExtraordinaryAssignmentButton
        tollExtraordinaryAssignmentId={tollExtraordinaryAssignmentId}
      />
    </div>
  </ButtonToolbar>
);

TollExtraordinaryAssignmentToolBar.propTypes = {
  tollExtraordinaryAssignmentId: PropTypes.number.isRequired,
};

export default TollExtraordinaryAssignmentToolBar;
